import { Routes } from '@angular/router';

import { APP_ROUTE_PATHS, DEFAULT_APP_ROUTE_PATH } from '@drf/shared/constants';

export const routes: Routes = [
  {
    path: APP_ROUTE_PATHS.root,
    loadComponent: () => import('./shell/shell.component').then(({ ShellComponent }) => ShellComponent),
    children: [
      {
        path: APP_ROUTE_PATHS.root,
        pathMatch: 'full',
        redirectTo: DEFAULT_APP_ROUTE_PATH,
      },
      {
        path: APP_ROUTE_PATHS.dashboard,
        loadChildren: () => import('./features/dashboard/routes/dashboard.routes').then(({ dashboardRoutes }) => dashboardRoutes),
      },
      {
        path: APP_ROUTE_PATHS.strategies,
        loadChildren: () => import('./features/strategies/routes/strategies.routes').then(({ strategiesRoutes }) => strategiesRoutes),
      },
      {
        path: APP_ROUTE_PATHS.analytics,
        loadChildren: () => import('./features/analytics/routes/analytics.routes').then(({ analyticsRoutes }) => analyticsRoutes),
      },
      {
        path: APP_ROUTE_PATHS.activity,
        loadChildren: () => import('./features/activity/routes/activity.routes').then(({ activityRoutes }) => activityRoutes),
      },
      {
        path: APP_ROUTE_PATHS.cards,
        loadChildren: () => import('./features/cards/routes/cards.routes').then(({ cardsRoutes }) => cardsRoutes),
      },
      {
        path: APP_ROUTE_PATHS.transfer,
        loadChildren: () => import('./features/transfer/routes/transfer.routes').then(({ transferRoutes }) => transferRoutes),
      },
      {
        path: APP_ROUTE_PATHS.settings,
        loadChildren: () => import('./features/settings/routes/settings.routes').then(({ settingsRoutes }) => settingsRoutes),
      },
      {
        path: APP_ROUTE_PATHS.support,
        loadChildren: () => import('./features/support/routes/support.routes').then(({ supportRoutes }) => supportRoutes),
      },
      {
        path: APP_ROUTE_PATHS.wildcard,
        redirectTo: DEFAULT_APP_ROUTE_PATH,
      },
    ],
  },
];
